export const authConstants = {
 
    SESSION_OK: 'SESSION_OK',
    SESSION_INVALID: 'SESSION_INVALID',
    SESSION_VOID: 'SESSION_VOID',
    SESSION_NOT_FOUND: 'SESSION_NOT_FOUND',

    LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
    LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
    LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',
    
    LOGOUT: 'USERS_LOGOUT',

    UPDATE_USER_PROFILE: 'UPDATE_USER_PROFILE',

    LOAD_SYS_PARAMS: 'LOAD_SYS_PARAMS'

};